import { gcpGroupInfo2CSV } from '^/hooks/useUploadContent';
import * as T from '^/types';
import { _export } from '../LengthElevationExportButton/length-elevation-export-button-utils';

export const downloadGCP = (info: T.GCPGroupContent['info']) => {
  const csv = gcpGroupInfo2CSV(info);
  _export(csv, csv.name.split('.')[0]);
};
